<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="搜索关键字" name="keyword"></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table">
                <c-table-column
                        label="产品号"
                        name="product_number"
                >
                </c-table-column>
                <c-table-column
                        label="产品中文名"
                        name="product_name"
                >
                </c-table-column>
                <c-table-column
                        label="产品英文名"
                        name="product_name_en"
                >
                </c-table-column>
                <c-table-column
                        label="产品CAS号"
                        name="product_cas_number"
                >
                </c-table-column>
                <c-table-column
                        label="规格"
                        name="spec"
                >
                </c-table-column>
                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="60"
                >
                    <template v-slot="row">
                        <c-table-button @click="navigateTo(`https://store.altascientific.com/#/mall/goods/detail?spuId=${row.data.product_id}`,true)">查看</c-table-button>
                    </template>
                </c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_feedback',
		
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
                    url: '/material/product/list',
					data
				});
			}
		}
	}
</script>